import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DocumentMaster } from '../model/DocumentMaster.model';
import { LectureMaster } from '../model/LectureMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';
import { DomSanitizer } from '@angular/platform-browser';
import { StudentLectureMaster } from '../model/StudentLectureMaster.model';
import { AskAQuery } from '../model/AskAQuery.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { StudentLectureContentMaster } from '../model/StudentLectureContentMaster.model';
import Player from '@vimeo/player';
import { User } from '../model/User.model';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
// import { ChatService } from '../service/socket.service';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-chapter-details',
  templateUrl: './chapter-details.component.html',
  styleUrls: ['./chapter-details.component.scss']
})
export class ChapterDetailsComponent implements OnInit {
  StudentlectureMasterTemp: StudentLectureMaster = new StudentLectureMaster();
  studentlectureMaster: StudentLectureMaster = new StudentLectureMaster();
  showDialog: boolean = false;
  documentMasterTemp: DocumentMaster = new DocumentMaster();
  student: StudentMaster = new StudentMaster();
  commentMaster: DocumentMaster = new DocumentMaster();
  player;
  askAQuery: AskAQuery = new AskAQuery();
  currentAskAQuery: AskAQuery = new AskAQuery();
  askQueryList: AskAQuery[] = [];
  showchatdiv: boolean = false;
  value: boolean = false;
  user: User = new User();
  setTitle: string;
  studentLectureContentVideos = new StudentLectureContentMaster();
  barPercent: number;
  errorBean: any = {}
  // private chatService: ChatService
  constructor(private mainService: MainserviceService, private authService: AuthService, private sanitizer: DomSanitizer, private router: Router,
    private messageService: MessageService,public spinnerService: NgxSpinnerService) { }

  ngOnInit() {
    this.spinnerService.show()
    this.student = this.authService.getUserSession();
    this.StudentlectureMasterTemp = this.authService.getlectureMasterSession();
    this.getLectureMasterById();
    this.getQuaryList();

    this.initPlayer();
    // this.chatService.sendMessage('Hello');

  }

  getLectureMasterById() {
    let studentlectureMasterVar = new StudentLectureMaster();
    studentlectureMasterVar.studentLectureMasterId = this.StudentlectureMasterTemp.studentLectureMasterId;
    this.mainService.getStudentLectureMasterById(studentlectureMasterVar).subscribe(data => {
      this.studentlectureMaster = data;
      console.log(this.studentlectureMaster,"studentlectureMaster");
      this.spinnerService.hide()
      this.documentMasterTemp.link = this.studentlectureMaster.studentLectureContentVideosList[0].documentMaster.link;
    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
      }
    })
  }


  takeAssessment() {

    this.authService.setlectureMasterSession(this.studentlectureMaster);
    this.router.navigateByUrl('/assessment');

  }

  toggleChat() {
    this.scrolltoBottom();
    this.showchatdiv = !this.showchatdiv;
  }

  closeChat() {
    this.showchatdiv = false;
  }
  openChat() {
    this.showchatdiv = true;
  }

  getQuaryList() {
    this.studentlectureMaster.studentLectureMasterId = this.StudentlectureMasterTemp.studentLectureMasterId;
    // this.studentlectureMaster.studentLectureMasterId=121;

    this.askAQuery.studentLectureMaster = this.studentlectureMaster;
    this.mainService.getAskAQueryList(this.askAQuery).subscribe(
      data => {
        this.askQueryList = data;

        this.scrolltoBottom();

      },
      error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      });
  }

  saveQuery() {

    let errorFlag = false;
    if (this.commentMaster.title == null || this.commentMaster.title == undefined || this.commentMaster.title == "") {
      this.errorBean.courseTagLine = true;
      errorFlag = true;
    } else {
      this.errorBean.courseTagLine = false;
    }

    if (errorFlag) {

      return;
    }



    let comments = new DocumentMaster();
    comments.title = this.commentMaster.title;
    comments.fileType = "TEXT"
    //comment = documentmaster

    this.saveAskAQuery(comments);

  }



  downloadDocument(askAQuery: AskAQuery) {

    if (askAQuery.comments.filePath != null) {
      this.downloadFile(askAQuery.comments.filePath);
    }

  }

  chapterIncomplete() {
    this.messageService.add({ severity: 'error', summary: 'Please Complete', detail: 'Previous Video.' });
  }






  saveAskAQuery(comments: DocumentMaster) {
    let createdBy = new User();
    createdBy.id = this.student.studentMasterId;

    let studentLectureMasterTemp = new StudentLectureMaster();
    studentLectureMasterTemp.studentLectureMasterId = this.StudentlectureMasterTemp.studentLectureMasterId;

    let askAQueryTemp = new AskAQuery()
    askAQueryTemp.createdBy = createdBy;
    askAQueryTemp.createdById = this.student.studentMasterId;
    askAQueryTemp.comments = comments;
    askAQueryTemp.studentLectureMaster = studentLectureMasterTemp;

    this.mainService.askAQuery(askAQueryTemp).subscribe(
      data => {

        this.askQueryList.push(data);
        this.getQuaryList();
        this.commentMaster.title = "";
        this.scrolltoBottom();

        // this.studentLectureMaster= data;
        // this.askQueryList=data;
      },
      error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }


  scrolltoBottom() {
    setTimeout(() => {
      var messageBody = document.querySelector('#messageBody');
      messageBody.scrollTop = messageBody.scrollHeight - messageBody.clientHeight;
    }, 100);
  }

  downloadFile(fileUrl: string) {

    if (fileUrl === null) {
      alert('No PDF to downlaod');
      return;
    }

    var fileUrlSplit = fileUrl.split("/");

    FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length - 1]);

  }


  //// video player functions

  viewDialog(studentLectureContentVideos: StudentLectureContentMaster) {
    this.studentLectureContentVideos = studentLectureContentVideos;

    this.documentMasterTemp = this.studentLectureContentVideos.documentMaster;
    this.documentMasterTemp.videoResumeTime = Math.round(+this.studentLectureContentVideos.watchedTime);

    if (this.documentMasterTemp.linkId != null && this.documentMasterTemp.linkId != undefined) {
      this.documentMasterTemp.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp.link);
    }

    this.showDialog = true;

    setTimeout(() => {
      this.setVideo(this.documentMasterTemp);
      this.setVideoTime(this.documentMasterTemp.videoResumeTime);
      this.updateVideoResumeTime();
    }, 500);

  }

  viewVideo(studentLectureContentVideos: StudentLectureContentMaster) {
    this.studentLectureContentVideos = studentLectureContentVideos;

    this.documentMasterTemp = this.studentLectureContentVideos.documentMaster;
    this.documentMasterTemp.videoResumeTime = Math.round(+this.studentLectureContentVideos.watchedTime);

    if (this.documentMasterTemp.linkId != null && this.documentMasterTemp.linkId != undefined) {
      this.documentMasterTemp.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp.link);
    }



    setTimeout(() => {
      this.setVideo(this.documentMasterTemp);
      this.setVideoTime(this.documentMasterTemp.videoResumeTime);

      this.updateVideoResumeTime();

    }, 500);

  }

  closeVideo() {

    this.showDialog = false;
    this.getLectureMasterById();
    if (this.player != null) {
      // this.player.destroy();
    }
  }

  public initPlayer() {
    this.player = new Player('video_iframe', {});
    // this.updateVideoCompleted();
  }

  setVideo(documentMaster: DocumentMaster) {

    this.initPlayer();

    this.player.loadVideo(documentMaster.linkId).then(function (id) {


    });


  }

  playVideo() {
    setTimeout(() => {
      this.player.play().then(function () {

      });
    }, 5000);

  }

  // updateVideoCompleted() {
  //   this.player.on('ended', function (data) {
  //   });
  // }

  setVideoTime(seconds) {

    setTimeout(() => {
      this.player.setCurrentTime(seconds).then(function (seconds) {
        // `seconds` indicates the actual time that the player seeks to
      })
      this.playVideo();
    }, 1000);

  }

  updateVideoResumeTime() {

    this.getVideoResumeTime(this.studentLectureContentVideos);

    if (this.studentLectureContentVideos.watchedTime == null) {
      this.studentLectureContentVideos.watchedTime = "0";
    }

    let barPercent = (Math.round(+this.studentLectureContentVideos.watchedTime) * 100 / this.studentLectureContentVideos.documentMaster.duration);

    if (this.barPercent != barPercent) {

      this.barPercent = barPercent;

      let studentLectureContentMasterTemp = new StudentLectureContentMaster();
      studentLectureContentMasterTemp.studentLectureContentMasterId = this.studentLectureContentVideos.studentLectureContentMasterId;
      studentLectureContentMasterTemp.watchedTime = this.studentLectureContentVideos.watchedTime;

      this.mainService.updateLastWatchedTime(studentLectureContentMasterTemp).subscribe(
        data => {

          if(this.barPercent>90){
            this.getLectureMasterById();
          }
    
        });

    }

    if (this.player != null) {
      setTimeout(() => {
        this.updateVideoResumeTime();
      }, 5000);
    }
  }

  getVideoResumeTime(studentLectureContentVideos: StudentLectureContentMaster) {


    if (this.player != null) {

      this.player.getCurrentTime().then(function (seconds) {

        studentLectureContentVideos.watchedTime = Math.round(seconds).toString();

      });

    }


  }


}
